import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class KindTypeModel extends BaseModel {

    constructor() {
        super({
                name: "kind_type",
                tableName: 'kind_type',
                label: "Danh Sách Chủng loại",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                kind_name: { 
                    name: 'name',
                    type: "String",
                    label: 'Loại',
                    sortable: false,
                    width: 12,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.kind_name = "";
                    }
                },
                name: {
                    name: 'kind_name',
                    type: "String",
                    label: 'Chủng loại',
                    sortable: false,
                    width: 12,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                number: {
                    name: 'number',
                    type: "String",
                    class: 'right',
                    label: 'Số lượng con',
                    computed: (data) => {
                        data.number = "";
                    }
                },
                import_weight: {
                    name: 'import_weight',
                    type: "String",
                    label: 'Tổng trọng lượng nhập (kg)',
                    computed: (data) => {
                        data.import_weight = "";
                    }
                },
                estimate_weight: {
                    name: 'estimate_weight',
                    type: "String",
                    label: 'Tổng trọng ước tính (kg)',
                    computed: (data) => {
                        data.estimate_weight = "";
                    }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Ngày cập nhật',
                    display: false
                },
                kinds: {
                    refs: 'kinds {id name code}',
                    display: false
                },
            },
            )
    }

}